const FlagNO = props => (
	<svg height="28" viewBox="0 0 200 200" width="28" {...props}>
		<rect fill="#ed5565" width="200" height="200" />
		<rect fill="#fff" x="80" y="-10.74" width="40" height="221.48" />
		<rect fill="#fff" x="80" y="-10.74" width="40" height="221.48" transform="translate(200 0) rotate(90)" />
		<rect fill="#4758a9" x="-4" y="90" width="208" height="20" transform="translate(200) rotate(90)" />
		<rect fill="#4758a9" x="-4" y="90" width="208" height="20" transform="translate(200 200) rotate(180)" />
	</svg>
);

export default FlagNO;
